import React from 'react'
import { parseErrorDetails } from 'services/util'

interface Props {
    message: string
    details?: string[]
    maxItems?: number
    /** When true, only grouped lists are shown (e.g. drawer with message in header). */
    omitMessage?: boolean
    className?: string
}

export const ErrorDetails: React.FC<Props> = ({
    message,
    details = [],
    maxItems = 3,
    omitMessage = false,
    className = '',
}) => {
    const parsed = parseErrorDetails(details)

    return (
        <div className={`max-w-full ${className}`.trim()}>
            {!omitMessage && (
                <div className="mb-3 text-sm text-slate-700 dark:text-slate-200">
                    {message}
                </div>
            )}

            <div className="space-y-5">
                {parsed.map((section, index) => {
                    const isLong = section.items.length > maxItems
                    const visibleItems = isLong
                        ? section.items.slice(0, maxItems)
                        : section.items

                    return (
                        <div key={index} className="space-y-2">
                            <h4 className="px-2 py-1 text-sm rounded bg-blue-100 text-blue-700 whitespace-nowrap dark:text-slate-100 dark:bg-slate-700">
                                {section.label}
                            </h4>

                            <ul className="list-disc space-y-1 pl-5 text-sm text-slate-600 dark:text-slate-300">
                                {visibleItems.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>

                            {isLong && (
                                <details className="pl-5 text-sm">
                                    <summary className="cursor-pointer text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200">
                                        +{section.items.length - maxItems} more
                                    </summary>

                                    <ul className="mt-2 list-disc space-y-1 pl-5 text-slate-600 dark:text-slate-300">
                                        {section.items
                                            .slice(maxItems)
                                            .map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                    </ul>
                                </details>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
